import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function initializeAnalytics() {
  if (!GA_MEASUREMENT_ID) {
    console.warn("Google Analytics measurement ID is not configured.");
    return;
  }

  ReactGA.initialize(GA_MEASUREMENT_ID);
}